import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { get } from 'lodash';
import Decimal from 'decimal.js';
import { types as sdkTypes } from '../../util/sdkLoader';
import { ensureListing } from '../../util/data';
import { getLodgingTax, getLodgingPricesOptions } from '../../util/listing';
import config from '../../config';
import EstimatedBreakdownMaybe from '../../forms/BookingDatesForm/EstimatedBreakdownMaybe';
import { LODGING_INFO, getPackageLodgingPrices } from '../../util/package';

import css from './InquiryBreakdown.module.css';

const { Money } = sdkTypes;

const InquiryBreakdown = ({ listing, formValues, intl }) => {
  const currentListing = ensureListing(listing);
  const { price: listingPrice } = currentListing.attributes;
  const { bookingDates, partySize, selectedPackage, lodgingAddons } = formValues || {};
  const { hasLodging } = selectedPackage;

  const { startDate, endDate, startLodgingDate } = bookingDates || {};

  const lodgingTax = getLodgingTax(listing, selectedPackage.id);
  const packageMinParty = get(selectedPackage, 'guests.min', 1);

  // Handle both standard party size and flexible pricing data
  let partySizeMaybe = packageMinParty;
  let flexiblePricingData = null;

  if (partySize) {
    if (typeof partySize === 'object' && partySize.partySize) {
      // Flexible pricing data
      partySizeMaybe = parseInt(partySize.partySize, 10);
      flexiblePricingData = partySize.flexibleGuestSize;
    } else {
      // Standard party size
      partySizeMaybe = parseInt(partySize, 10);
    }
  }

  const lodgingPricesOptions = getLodgingPricesOptions(listing, intl);
  const { optionalLodging, includedLodging } = getPackageLodgingPrices(
    selectedPackage,
    lodgingPricesOptions
  );

  let packageItem = null;
  const speciesFeeCalc = {};

  const packagePrice = selectedPackage.price;
  const packageFee = new Money(packagePrice.amount, config.currency);

  let lodgingFees = (lodgingAddons || []).map(addon => {
    const lodgingPrice = JSON.parse(optionalLodging[addon].price, sdkTypes.reviver);

    return {
      price: lodgingPrice,
      type: optionalLodging[addon].type,
    };
  });

  if (includedLodging?.length) {
    lodgingFees = lodgingFees.concat(
      includedLodging.map(item => {
        const lodgingPrice = JSON.parse(item.price, sdkTypes.reviver);

        return {
          price: lodgingPrice,
          type: item.type,
        };
      })
    );
  }

  const includeLodging = lodgingAddons?.length > 0 || hasLodging === LODGING_INFO.REQUIRED;

  packageItem = {
    code: `line-item/${selectedPackage.title.replace(/\s/g, '-')}`,
    title: selectedPackage.title,
    includeFor: ['customer', 'provider'],
    unitPrice: packageFee,
    quantity: new Decimal(1),
    lineTotal: packageFee,
    reversal: false,
    guestSize: partySizeMaybe,
    activity: selectedPackage.activity,
    hasLodging: includeLodging,
    lodgingFees,
  };

  const bookingData = {
    unitType: config.bookingUnitType,
    unitPrice: listingPrice,
    startDate,
    endDate,
    startLodgingDate,
    quantity: 1,
    partySize: partySizeMaybe,
    packageItem,
    lodgingTax: includeLodging && lodgingTax,
    flexiblePricing: flexiblePricingData,
    ...speciesFeeCalc,
  };

  return (
    <div className={css.root}>
      <EstimatedBreakdownMaybe
        bookingData={bookingData}
        listing={listing}
        packageInfo={selectedPackage}
        totalLabel={<FormattedMessage id="InquiryWizard.estimatedTotal" />}
      />
    </div>
  );
};

export default injectIntl(InquiryBreakdown);
